import type { ApplicationStatus } from '~/types/code/code';

/**
 * 申請ステータスの列挙型
 */
export const ApplicationStatusEnum = {
  /** 未承認 */
  PENDING: 'PENDING',
  /** 承認済 */
  APPROVED: 'APPROVED',
  /** 却下済 */
  REJECTED: 'REJECTED',
  /** 申請取消 */
  CANCEL: 'CANCEL',
} as const satisfies Record<ApplicationStatus, ApplicationStatus>;

const APPLICATION_STATUS_LABELS: Record<ApplicationStatus, string> = {
  PENDING: '未承認',
  APPROVED: '承認済',
  REJECTED: '却下済',
  CANCEL: '申請取消',
};

/**
 * 申請ステータスラベルを取得する
 *
 * @param status 申請ステータス
 * @returns 申請ステータスラベル
 */
export const getApplicationStatusLabel = (status: ApplicationStatus) =>
  APPLICATION_STATUS_LABELS[status] ?? '';
